module.exports = __webpack_public_path__ + "img/visa-icon.af9b1802.png";